import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Services from './pages/Services';
import Pricing from './pages/Pricing';
import About from './pages/About';
import Blogs from './pages/Blogs';
import Contact from './pages/Contact';
import GetStartedNow from './pages/GetStartedNow';
import TollFreeOrigination from './pages/TollFreeOrigination';
import InboundOrigination from './pages/InboundOrigination';
import DIDServices from './pages/DIDServices';
import TollFreeTermination from './pages/TollFreeTermination';
import DialerTermination from './pages/DialerTermination';
import WholesaleTermination from './pages/WholesaleTermination';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solutions" element={<Services />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/getstartednow" element={<GetStartedNow />} />
          <Route path="/toll-free-origination" element={<TollFreeOrigination />} />
          <Route path="/inbound-origination" element={<InboundOrigination />} />
          <Route path="/did-services" element={<DIDServices />} />
          <Route path="/toll-free-termination" element={<TollFreeTermination />} />
          <Route path="/dialer-termination" element={<DialerTermination />} />
          <Route path="/wholesale-termination" element={<WholesaleTermination />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;


